import React from 'react';
import BarChartIcon from '../icons/BarChartIcon';

export default function ScannerCTA({ continuousMode, setContinuousMode, onScanClick }) {
  return (
    <div className="bg-gradient-to-br from-[#00D26A]/20 via-zinc-900 to-[#FFD700]/10 border border-[#00D26A]/30 rounded-lg shadow-lg p-8 mb-6 text-white">
      <h2 className="text-3xl font-bold mb-3">
        Ready to Find the <span className="text-[#FFD700]">Best</span> Prices?{' '}
        <BarChartIcon size="0.9em" className="ml-1" />
      </h2>
      <p className="text-zinc-300 mb-6">
        Scan or enter a barcode to check prices across all four major UK buyers — cash and voucher.
      </p>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <button
          onClick={onScanClick}
          data-testid="scan-barcode-button"
          className="bg-[#00D26A] text-black px-8 py-4 rounded-lg font-bold text-lg hover:brightness-110 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
        >
          📷 Scan Barcode Now
        </button>
        <label
          className="inline-flex items-center gap-3 bg-black/40 hover:bg-black/60 border border-[#FFD700]/30 rounded-lg px-4 py-3 cursor-pointer select-none transition-colors"
          data-testid="continuous-mode-toggle-label"
        >
          <input
            type="checkbox"
            checked={continuousMode}
            onChange={(e) => setContinuousMode(e.target.checked)}
            data-testid="continuous-mode-toggle"
            className="w-5 h-5 accent-[#00D26A] cursor-pointer"
          />
          <span className="text-sm font-semibold">
            Continuous scanning
            <span className="block text-xs font-normal text-zinc-400">
              Scan a pile back-to-back without reopening the scanner
            </span>
          </span>
        </label>
      </div>
    </div>
  );
}
